<template>
  <div class="page-container">
    <!-- 背景装饰层 -->
    <div class="bg-decoration"></div>

    <!-- 主内容容器 -->
    <div class="main-content">
      <!-- 顶部装饰与标题区域 -->
      <div class="header-section">
        <div class="decorative-frame">
          <dv-decoration-8 class="decor-left" />
          <dv-decoration-8 class="decor-right" :reverse="true" />
        </div>

        <div class="title-wrapper">
          <div class="main-title">旅游大数据产业分析模块</div>
          <div class="subtitle">全面洞察·智慧决策</div>
        </div>
      </div>

      <!-- 功能菜单网格 -->
      <div class="functions-grid">
        <div
            class="function-card"
            @click="nav('/dataCenterScreen')"
            :class="{ 'highlight-card': isHighlighted('/dataCenterScreen') }"
        >
          <div class="card-icon">
            <img src="@/image/index/sqlCenter.png" alt="互联网数据中心">
          </div>
          <div class="card-name">互联网数据中心</div>
        </div>

        <div
            class="function-card"
            @click="nav('/tourismPublicOpiniocScreen')"
            :class="{ 'highlight-card': isHighlighted('/tourismPublicOpiniocScreen') }"
        >
          <div class="card-icon">
            <img src="@/image/Nav/yuqingjiance.png" alt="舆情监测">
          </div>
          <div class="card-name">舆情监测</div>
        </div>

        <div
            class="function-card"
            @click="nav('/propagationAnalysis')"
            :class="{ 'highlight-card': isHighlighted('/propagationAnalysis') }"
        >
          <div class="card-icon">
            <img src="@/image/Nav/chuanbofenxi.png" alt="传播分析">
          </div>
          <div class="card-name">传播分析</div>
        </div>

        <div
            class="function-card"
            @click="nav('/touristSatisfaction')"
            :class="{ 'highlight-card': isHighlighted('/touristSatisfaction') }"
        >
          <div class="card-icon">
            <img src="@/image/Nav/youkemanyiduguanli.png" alt="游客满意度">
          </div>
          <div class="card-name">游客满意度</div>
        </div>

        <div
            class="function-card"
            @click="nav('/brandEvaluation')"
            :class="{ 'highlight-card': isHighlighted('/brandEvaluation') }"
        >
          <div class="card-icon">
            <img src="@/image/Nav/jingdian.png" alt="景点评估">
          </div>
          <div class="card-name">品牌评估</div>
        </div>

        <div
            class="function-card"
            @click="nav('/passengerFlow')"
            :class="{ 'highlight-card': isHighlighted('/passengerFlow') }"
        >
          <div class="card-icon">
            <img src="@/image/Nav/shishikeliu.png" alt="实时客流">
          </div>
          <div class="card-name">实时客流</div>
        </div>

        <div
            class="function-card"
            @click="nav('/passengerFlowTrend')"
            :class="{ 'highlight-card': isHighlighted('/passengerFlowTrend') }"
        >
          <div class="card-icon">
            <img src="@/image/Nav/keliuqushi.png" alt="客流趋势分析">
          </div>
          <div class="card-name">客流趋势分析</div>
        </div>

        <div
            class="function-card"
            @click="nav('/UserPortrait')"
            :class="{ 'highlight-card': isHighlighted('/UserPortrait') }"
        >
          <div class="card-icon">
            <img src="@/image/Nav/youkexingweihuaxiang.png" alt="游客行为画像">
          </div>
          <div class="card-name">游客行为画像</div>
        </div>

        <div
            class="function-card"
            @click="nav('/travelRelatedConsumption')"
            :class="{ 'highlight-card': isHighlighted('/travelRelatedConsumption') }"
        >
          <div class="card-icon">
            <img src="@/image/Nav/shelvxiaofeifenxi.png" alt="涉旅消费分析">
          </div>
          <div class="card-name">涉旅消费分析</div>
        </div>

        <div
            class="function-card"
            @click="nav('/passengerFlowDistribution')"
            :class="{ 'highlight-card': isHighlighted('/passengerFlowDistribution') }"
        >
          <div class="card-icon">
            <img src="@/image/Nav/keliufenbu.png" alt="客流分布">
          </div>
          <div class="card-name">客流分布</div>
        </div>
      </div>

      <!-- 底部信息 -->
      <div class="footer-info">
        <div class="system-status">
          <span class="status-indicator"></span>
          系统运行正常
        </div>
        <div class="copyright">© {{time}} 云驴通分析平台 版权所有</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 当前激活的路由
      currentRoute: '',
      time:null,
    }
  },
  mounted() {
    // 获取当前路由
    this.currentRoute = this.$route.path;

    // 监听路由变化
    this.$watch('$route.path', (newVal) => {
      this.currentRoute = newVal;
    });
    this.time = new Date().getFullYear();

    // 添加页面载入动画
    document.body.classList.add('page-loaded');
  },
  methods: {
    nav(path) {
      this.$router.replace({ path });
    },
    // 判断是否为当前高亮路由
    isHighlighted(path) {
      return this.currentRoute === path;
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.page-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  font-family: 'Microsoft YaHei', 'Segoe UI', sans-serif;
}

/* 背景样式 */
.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
      url("../../assets/pageBg.png"),
      radial-gradient(circle at 50% 50%, rgba(30, 60, 100, 0.3), transparent 70%);
  background-size: cover;
  background-position: center;
  background-blend-mode: overlay;
  z-index: 1;
}

/* 主内容容器 */
.main-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 头部区域 */
.header-section {
  position: relative;
  margin-bottom: 40px;
}

.decorative-frame {
  display: flex;
  width: 100%;
  height: 80px;
  justify-content: center;
  align-items: center;
  position: relative;
}

.decor-left, .decor-right {
  width: 30%;
  height: 80px;
  opacity: 0.8;
}

.title-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
}

.main-title {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 0 15px rgba(100, 180, 255, 0.6), 0 2px 4px rgba(0, 0, 0, 0.5);
  margin-bottom: 8px;
  letter-spacing: 3px;
}

.subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  letter-spacing: 1px;
}

/* 功能网格 */
.functions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 25px;
  width: 90%;
  max-width: 1400px;
  margin: 0 auto;
  flex-grow: 1;
  align-items: center;
}

/* 功能卡片样式 */
.function-card {
  background: rgba(20, 30, 50, 0.7);
  border: 1px solid rgba(100, 180, 255, 0.2);
  border-radius: 12px;
  padding: 25px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 160px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

/* 卡片悬停效果 */
.function-card:hover {
  transform: translateY(-8px) scale(1.03);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-color: rgba(100, 180, 255, 0.5);
  background: rgba(25, 35, 60, 0.85);
}

/* 卡片图标区域 */
.card-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  border-radius: 50%;
  background: rgba(100, 180, 255, 0.1);
  transition: all 0.3s ease;
}

.function-card:hover .card-icon {
  background: rgba(100, 180, 255, 0.2);
  transform: scale(1.1) rotate(5deg);
}

.card-icon img {
  width: 36px;
  height: 36px;
  object-fit: contain;
  transition: all 0.3s ease;
}

/* 卡片名称 */
.card-name {
  font-size: 18px;
  color: #ffffff;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.function-card:hover .card-name {
  color: #b3d4fc;
}

/* 当前选中卡片样式 */
.highlight-card {
  border-color: rgba(100, 200, 255, 0.8);
  background: rgba(30, 45, 80, 0.9);
  box-shadow: 0 0 20px rgba(100, 180, 255, 0.3);
}

.highlight-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  background: linear-gradient(to bottom, #64b4ff, #3a8ee6);
}

/* 底部信息 */
.footer-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 50px;
  margin-top: 40px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.system-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #4cd964;
  box-shadow: 0 0 10px rgba(76, 217, 100, 0.6);
  animation: pulse 2s infinite;
}

/* 动画效果 */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

/* 页面载入动画 */
.page-loaded .function-card {
  animation: fadeInUp 0.6s ease forwards;
  opacity: 0;
}

/* 为每个卡片添加延迟动画，营造错落有致的效果 */
.page-loaded .function-card:nth-child(1) { animation-delay: 0.1s; }
.page-loaded .function-card:nth-child(2) { animation-delay: 0.2s; }
.page-loaded .function-card:nth-child(3) { animation-delay: 0.3s; }
.page-loaded .function-card:nth-child(4) { animation-delay: 0.4s; }
.page-loaded .function-card:nth-child(5) { animation-delay: 0.5s; }
.page-loaded .function-card:nth-child(6) { animation-delay: 0.6s; }
.page-loaded .function-card:nth-child(7) { animation-delay: 0.7s; }
.page-loaded .function-card:nth-child(8) { animation-delay: 0.8s; }
.page-loaded .function-card:nth-child(9) { animation-delay: 0.9s; }
.page-loaded .function-card:nth-child(10) { animation-delay: 1s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .functions-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  .main-title {
    font-size: 32px;
  }
}

@media (max-width: 900px) {
  .functions-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .footer-info {
    flex-direction: column;
    gap: 10px;
    padding: 0 20px;
  }
}

@media (max-width: 600px) {
  .functions-grid {
    grid-template-columns: repeat(2, 1fr);
    width: 95%;
  }

  .main-title {
    font-size: 26px;
  }

  .decor-left, .decor-right {
    width: 40%;
  }

  .function-card {
    height: 140px;
    padding: 20px 10px;
  }

  .card-name {
    font-size: 16px;
  }
}
</style>
